export default "__VITE_ASSET__B8R4$Nor__"